<template>
    <div class="page_panel">
        <div class="page_main">
            <span class="list_number">共{{nums}}条数据</span>
            <div class="page_content">
            <ul>
                <li class="page_list" v-on:click="prevPage()">&lt;</li>
                <li v-bind:class="{active:currentIndex == i}" class="page_list" v-for="i in pageList" v-on:click="changePage(i)">{{i}}</li>
                <li class="page_list" v-on:click="nextPage()">&gt;</li>
            </ul>
            </div>
            <span class="show_current">显示{{showstart}}-{{showend}}条数据</span>
            <span>每页</span>
            <select name="" id="" v-model="pageSize" @change="changePageSize()">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
            </select>
            <span>条</span>
        </div>
    </div>
</template>
<script>
export default {
  name: "Pagination",
  props: ["nums"],
  data() {
    return {
      pageSize: 10,
      pageStart: 0,
      pageList: [],
      pageNum: "",
      showstart: 1,
      showend: 10,
      currentIndex: 1,
      showPageMumber: "",
      maxPage: 10
    };
  },
  mounted: function() {
    this.$nextTick(() => {
      this.showend = this.nums < 10 ? this.nums : 10;
      this.getPageList();
    });
  },
  methods: {
    changePageSize: function() {
      this.pageNum = Math.ceil(this.nums / this.pageSize);
      this.currentIndex =
        this.currentIndex > this.pageNum ? this.pageNum : this.currentIndex;
      this.getPageFromTo();
      this.getPageList();
      //const page = new pageInfo(this.showstart, this.showend);
      //this.pageClick.emit(page);
      this.$emit("setPage", this.showstart, this.showend, this.pageSize, this.currentIndex);
    },
    changePage: function(index) {
      this.pageStart = (index - 1) * this.pageSize;
      this.currentIndex = index;
      this.getPageFromTo();
      //const page = new pageInfo(this.showstart, this.showend);
      //this.pageClick.emit(page);
      this.$emit("setPage", this.showstart, this.showend, this.pageSize, this.currentIndex);
    },
    prevPage: function() {
      if (this.currentIndex == 1) {
        return;
      } else if (this.pageNum > this.maxPage) {
        this.getPageList("prev");
        this.changePage(this.currentIndex - 1);
      } else {
        this.changePage(this.currentIndex - 1);
      }
    },
    nextPage: function() {
      if (this.currentIndex >= this.pageNum) {
        return;
      } else if (this.currentIndex >= this.showPageMumber) {
        this.getPageList("next");
        this.changePage(this.currentIndex + 1);
      } else {
        this.changePage(this.currentIndex + 1);
      }
    },
    getPageFromTo: function() {
      this.showstart = (this.currentIndex - 1) * this.pageSize + 1;
      this.showend =
        this.currentIndex * this.pageSize > this.nums
          ? this.nums
          : this.currentIndex * this.pageSize;
    },
    getPageList: function(status) {
      this.pageList = [];
      //this.nums = this.$store.state.userLength;
      console.log(this.nums);
      if(this.nums != this.$store.state.userLength){
        this.pageNum = Math.ceil(this.$store.state.userLength / this.pageSize);
      }else{
        this.pageNum = Math.ceil(this.nums / this.pageSize);
      }
      //this.pageNum = Math.ceil(this.nums / this.pageSize);
      this.showPageMumber = this.pageNum;
      if (this.pageNum > this.maxPage) {
        this.showPageMumber = this.maxPage;
      }
      let startList = 1;
      if (this.currentIndex >= this.maxPage && status == "next") {
        startList = this.currentIndex - this.maxPage + 2;
      } else if (this.currentIndex > this.maxPage && status == "prev") {
        startList = this.currentIndex - this.maxPage;
      }
      this.currentIndex - this.maxPage;
      for (let i = startList; i <= this.showPageMumber + startList - 1; i++) {
        this.pageList.push(i);
      }
      if (this.pageNum > this.maxPage) {
        this.pageList.splice(2, 0, "...");
      }
      if(this.currentIndex > this.pageList.length){
        this.currentIndex = this.pageList.length;
        this.showstart = (this.currentIndex - 1) * this.pageSize;
        this.showend = this.currentIndex * this.pageSize;
      }
    }
  }
};
</script>
<style scoped>
.page_panel {
  overflow: hidden;
  margin-top: 0.15rem;
  margin-right: 0.22rem;
}
.page_panel .page_main {
  float: right;
}
.page_panel .list_number {
  margin-right: 20px;
}
.page_content {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  vertical-align: middle;
}
ul {
  list-style: none;
  overflow: hidden;
}
.page_list {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin: 0 10px;
  float: left;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.active {
  background-color: #fa5400;
  color: #fff;
}
.show_current {
  margin: 0 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Pagination.vue